<div class="container-fluid vh-100 p-0" style="position: fixed">
  <div class="row h-100">
    <!-- Full-Screen Background Image -->
    <div class="col-12 p-0">
      <img
        class="img-fluid w-100"
        src="assets/Images/bg-image.jpg"
        alt="Background Image"
        style="object-fit: cover; height: 100vh"
      />
    </div>
    <!-- Right Side Login Form -->
    <div
      class="col-12 d-flex align-items-center justify-content-center position-absolute top-0 start-0 h-100"
    >
      <div class="glass-card w-75 w-md-50 w-lg-40 p-4 rounded-4 shadow-lg">
        <div class="text-center mb-4">
          <img
            class="img-logo"
            src="assets/Images/CDM-01.png"
            alt="Logo"
            style="max-width: 120px; width: 100%; height: auto"
          />
        </div>
        <form [formGroup]="loginForm" (ngSubmit)="loginSubmit()">
          <div class="mb-3">
            <label for="username" class="form-label text-black"
              ><strong>Username</strong></label
            >
            <input
              type="text"
              class="form-control"
              formControlName="userName"
              [ngClass]="{
                'invalid-field': submitted && f['userName'].errors
              }"
            />
            <div
              *ngIf="submitted && f['userName'].errors"
              class="invalid-feedback"
            >
              <div *ngIf="f['userName'].errors?.['required']">
                Username is required
              </div>
            </div>
          </div>
          <div class="mb-3 position-relative">
            <label for="password" class="form-label text-black"
              ><strong>Password</strong></label
            >
          <input
    [type]="showPassword ? 'text' : 'password'"
    formControlName="password"
    autocomplete="new-password"
    class="form-control"
    [ngClass]="{ 'invalid-field': submitted && f['password'].errors }"
  />
            <!-- Eye Icon -->
  <button
    type="button"
    class="btn btn-outline-secondary position-absolute end-0 me-2"
  style="top: 45%; padding: 5px; height: auto;"
  tabindex="-1"
   
    (click)="togglePassword()"
  >
    <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
  </button>

            <div
              *ngIf="submitted && f['password'].errors"
              class="invalid-feedback"
            >
              <div *ngIf="f['password'].errors?.['required']">
                Password is required
              </div>
              <div *ngIf="f['password'].errors?.['minlength']">
                Password must be at least 6 characters long
              </div>
            </div>
          </div>
          <div class="text-center">
            <button
              type="submit"
              class="btn btn-primary login-submit w-100"
              [ngStyle]="{ width: isLoading ? '50%' : '27%' }"
            >
              <span
                *ngIf="isLoading"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              {{ isLoading ? "Logging in..." : "Sign In" }}
            </button>
          </div>
        </form>
        <div class="text-center mt-3 text-white-50">
          <p>Powered by: TD</p>
        </div>
      </div>
    </div>
  </div>
</div>

